import useToast from '@hooks/useToast'
import useTransactionOtherParty from '@plug-core/hooks/useTransactionOtherParty'
import { PlugUserActivity } from '@plug-core/interfaces/transactionActivity'
import { cn } from '@ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const TransactionOtherParty = ({
  activity,
  long,
  copy,
}: {
  activity: PlugUserActivity
  long?: boolean
  copy?: boolean
}) => {
  const { t } = useTranslation()
  const { setToastMessage } = useToast()
  const { otherParty, isRecognized, fullAddress } = useTransactionOtherParty({
    activity,
    long,
  })

  const onCopy = () => {
    if (!copy) return

    setToastMessage(t('deposit.addressCopied'))
    navigator.clipboard.writeText(fullAddress)
  }

  return (
    <span
      onClick={onCopy}
      className={cn(isRecognized ? 'font-text text-info' : 'font-mono', copy && 'cursor-pointer')}
    >
      {otherParty}
    </span>
  )
}
